import React from 'react'

import SelectField from '../Fields/SelectField'

const OPTIONS = [
  { value: null, name: 'All' },
  { value: 'active', name: 'Active' },
  { value: 'inactive', name: 'Inactive' }
]

function ActiveStatusField (props) {
  return (
    <SelectField
      name="status"
      label="Status"
      options={OPTIONS}
      {...props}
    />
  )
}

export default ActiveStatusField
